import React, { useState, Fragment, useEffect } from "react";
import axios from "axios";
import Container from "@mui/material/Container";
import Buttons from "../Button/Button";
import FilterIcon from "../../assets/imgs/Filter.png";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ModalOne from "../Modals/ModalOne";
import InProgress from "./InProgress";
import Upcoming from "./Upcoming";
import AllCourses from "./AllCourses";
import Filter from "../Filter/Filter";
import Grid from "@mui/material/Grid";

import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";

import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";

import CustomizedSnackbar from "../../hooks/Snackbar";

import TagFacesIcon from "@mui/icons-material/TagFaces";
import styles from "./Session.module.css";
import EmptyCourse from "../EmptyCourse/EmptyCourse";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div p={1}>
          {/* p tag has issues wrapping div tags with NextJS */}
          <div>{children}</div>
        </div>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function Session(props) {
  const { setUpdateCart, enrollNowHandler, setOpenSignUpModel } = props;

  const [value, setValue] = useState(0);
  const [inprogressCourses, setInprogressCourses] = useState([]);
  const [upcommingCourses, setUpcommingCourses] = useState([]);
  const [completedCourses, setCompletedCourses] = useState([]);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // severity can be: success, error, warning, info, success
  const [snackbarMessage, setSnackbarMessage] = useState("");

  useEffect(() => {
    if (props?.data?.inprogress && props?.data?.inprogress?.length > 0) {
      setInprogressCourses(props?.data?.inprogress);
    }

    // console.log("DEBUG SESSION: props.data", props?.data);
    const upcoming = props?.data?.upcomming || props?.data?.upcoming;
    if (upcoming && upcoming.length > 0) {
      setUpcommingCourses(upcoming);
    }

    if (props?.data?.completed && props?.data?.completed?.length > 0) {
      setCompletedCourses(props?.data?.completed);
    }
  }, [props]);
  /**
   * When click on snackbar close btn
   */
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setShowSnackbar(false);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [age, setAge] = React.useState("");

  const handleChangeSelect = (event) => {
    setAge(event.target.value);
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [chipData, setChipData] = React.useState([
    // { key: 0, label: 'Quran' },
    // { key: 1, label: 'Hadith' },
    // { key: 2, label: 'Salah' },
    // { key: 3, label: 'Nasheed' },
    // { key: 4, label: 'Philosophy' },
  ]);

  const handleDelete = (chipToDelete) => () => {
    setChipData((chips) =>
      chips.filter((chip) => chip.key !== chipToDelete.key)
    );
  };

  return (
    <div className="Section" style={{ marginTop: "-6px" }}>
      <Container maxWidth="lg">
        <div className="TabContainer">
          <div className="TabHeader" style={{ marginBottom: "41px" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab label={<p>All</p>} {...a11yProps(0)} />
              <Tab label={<p>Upcoming</p>} {...a11yProps(1)} />
              <Tab label={<p>In-progress</p>} {...a11yProps(2)} />
            </Tabs>

            <div className="FilterContainer">
              <div onClick={handleOpen}>
                {/* <Buttons
                  label="Filters"
                  buttonColor="#fff"
                  color="#0B132B"
                  height="56px"
                  fontSize="16px"
                  border="#D2D3D8 1px solid"
                  icon={<img src={FilterIcon} style={{ width: '24px', marginRight: "8px", }} />}
                /> */}
              </div>

              <div className={styles.SelectField}>
                {/* <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Sort by</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={age}
                    label="Age"
                    onChange={handleChangeSelect}
                  >
                    <MenuItem value={10}>Most popular</MenuItem>
                    <MenuItem value={20}>Most popular</MenuItem>
                    <MenuItem value={30}>Most popular</MenuItem>
                  </Select>
                </FormControl> */}
              </div>
            </div>
          </div>

          <div className={styles.ChipContainer}>
            {chipData?.map((data) => {
              let icon;
              return (
                <div key={data.key} className={styles.chipBox}>
                  <Chip
                    icon={icon}
                    label={data.label}
                    onDelete={
                      data.label === "React" ? undefined : handleDelete(data)
                    }
                  />
                </div>
              );
            })}
          </div>

          <TabPanel value={value} index={0}>
            {(upcommingCourses && upcommingCourses?.length > 0
              ? upcommingCourses?.length
              : 0) +
              (inprogressCourses && inprogressCourses?.length > 0
                ? inprogressCourses?.length
                : 0) ? (
              <AllCourses
                upcommingCourses={upcommingCourses}
                inprogressCourses={inprogressCourses}
                completedCourses={completedCourses}
                setUpdateCart={setUpdateCart}
                enrollNowHandler={enrollNowHandler}
                setOpenSignUpModel={setOpenSignUpModel}
              />
            ) : (
              <EmptyCourse
                MainTitle={true}
                Title="Courses coming soon!"
                Description="No courses published yet. Please, check back again later!"
              />
            )}
          </TabPanel>
          <TabPanel value={value} index={1}>
            {upcommingCourses && upcommingCourses?.length > 0 ? (
              <Upcoming
                courses={upcommingCourses}
                setUpdateCart={setUpdateCart}
                enrollNowHandler={enrollNowHandler}
                setOpenSignUpModel={setOpenSignUpModel}
              />
            ) : (
              <EmptyCourse
                MainTitle={true}
                Title="Courses coming soon!"
                Description="No courses published yet. Please, check back again later!"
              />
            )}
          </TabPanel>
          <TabPanel value={value} index={2}>
            {inprogressCourses && inprogressCourses?.length > 0 ? (
              <InProgress
                courses={inprogressCourses}
                setUpdateCart={setUpdateCart}
                enrollNowHandler={enrollNowHandler}
                setOpenSignUpModel={setOpenSignUpModel}
              />
            ) : (
              <EmptyCourse
                MainTitle={true}
                Title="Courses coming soon!"
                Description="No courses published yet. Please, check back again later!"
              />
            )}
          </TabPanel>
        </div>

        <ModalOne
          open={open}
          handleClose={handleClose}
          width="390px"
          Modaltitle="Filter"
          titileColor="#33B651"
          padding="16px"
          body={
            <div>
              <Filter />
            </div>
          }
        />
      </Container>
      <CustomizedSnackbar
        open={showSnackbar}
        severity={snackbarSeverity}
        message={snackbarMessage}
        handleClose={handleSnackbarClose}
      />
    </div>
  );
}

export default Session;
